// src/utils/presence.js

function resolveT(t) {
  return typeof t === "function"
    ? t
    : (_key, opts = {}) => opts.defaultValue || "";
}

export function getPresenceLabelI18n(u, t) {
  const tt = resolveT(t);
  if (!u) return "";

  const prem = u.premium || {};
  const expMs = prem?.expiresAt?.toMillis?.() || 0;
  if (
    prem.active === true &&
    expMs > Date.now() &&
    u?.settings?.messages?.vpnShowOnline === false
  ) {
    return "";
  }

  // Phase N9D: Busy (server-authoritative inCall mirror, see
  // functions/calls/locks.js) takes priority over Online everywhere.
  if (u.inCall === true) {
    return tt("presence.busy_now", { defaultValue: "Busy now" });
  }

  // ✅ متصل الآن
  if (u.online === true && u.inApp === true) {
    return tt("presence.online_now", { defaultValue: "متصل الآن" });
  }

  const ts = u?.lastSeenAt;
  const d = ts?.toDate?.();

  if (!d) return tt("presence.offline", { defaultValue: "غير متصل" });

  const now = new Date();
  const diffMs = Math.max(0, now.getTime() - d.getTime());
  const minuteMs = 60 * 1000;
  const hourMs = 60 * minuteMs;
  const dayMs = 24 * hourMs;

  if (diffMs < hourMs) {
    const minutes = Math.max(1, Math.floor(diffMs / minuteMs));
    if (minutes === 1) {
      return tt("presence.last_seen_since_minute", {
        defaultValue: "آخر ظهور منذ دقيقة",
      });
    }
    return tt("presence.last_seen_since_minutes", {
      defaultValue: "آخر ظهور منذ {{count}} دقائق",
      count: minutes,
    });
  }

  if (diffMs < dayMs) {
    const hours = Math.max(1, Math.floor(diffMs / hourMs));
    if (hours === 1) {
      return tt("presence.last_seen_since_hour", {
        defaultValue: "آخر ظهور منذ ساعة",
      });
    }
    return tt("presence.last_seen_since_hours", {
      defaultValue: "آخر ظهور منذ {{count}} ساعات",
      count: hours,
    });
  }

  const days = Math.max(1, Math.floor(diffMs / dayMs));
  if (days === 1) {
    return tt("presence.last_seen_since_day", {
      defaultValue: "آخر ظهور منذ يوم",
    });
  }
  return tt("presence.last_seen_since_days", {
    defaultValue: "آخر ظهور منذ {{count}} أيام",
    count: days,
  });
}

export function getPresenceLabel(u, t) {
  return getPresenceLabelI18n(u, t);
}